import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import ScaleIcon from '@mui/icons-material/Scale';
import TableViewIcon from '@mui/icons-material/TableView';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import StyleIcon from '@mui/icons-material/Style';
import BugReportIcon from '@mui/icons-material/BugReport';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import TuneIcon from '@mui/icons-material/Tune';
import PageHeader from '../common/PageHeader';

const ITEMS = [
  {
    title: 'Carga de balança',
    description: 'Gera TXITENS.txt (Toledo) e CADTXT.txt (Filizola), igual ao ZenPDV.',
    route: '/utilities/scale-load',
    icon: <ScaleIcon fontSize="large" color="primary" />,
  },
  {
    title: 'Excel de produtos',
    description: 'Importa e exporta no mesmo modelo de planilha do ZenPDV.',
    route: '/utilities/excel',
    icon: <TableViewIcon fontSize="large" color="success" />,
  },
  {
    title: 'Excel de clientes',
    description: 'Importa e exporta cadastro de clientes (CPF/CNPJ, endereço, IE).',
    route: '/utilities/excel-clientes',
    icon: <TableViewIcon fontSize="large" color="info" />,
  },
  {
    title: 'Gerar etiquetas',
    description: 'Seleciona produtos, imprime folha com código de barras ou baixa RAW.',
    route: '/utilities/labels',
    icon: <QrCode2Icon fontSize="large" color="primary" />,
  },
  {
    title: 'Modelos de etiqueta',
    description: 'Desenhe a etiqueta ou cole o código da impressora. Exporte e importe arquivos .zetiq.',
    route: '/utilities/label-models',
    icon: <StyleIcon fontSize="large" color="secondary" />,
  },
  {
    title: 'Reajuste de produtos',
    description: 'Atualiza cadastro e preços em lote por grupo, subgrupo e faixa de código de barras.',
    route: '/utilities/reajuste-produtos',
    icon: <TuneIcon fontSize="large" color="primary" />,
  },
  {
    title: 'Copiar preços entre filiais',
    description: 'Replica varejo, atacado, promocional e custo de uma filial para outra.',
    route: '/utilities/copiar-precos-filial',
    icon: <PriceChangeIcon fontSize="large" color="warning" />,
  },
  {
    title: 'Erros do PDV',
    description: 'Consultar falhas enviadas pelos caixas (NFC-e, sync, crashes).',
    route: '/utilities/pdv-erros',
    icon: <BugReportIcon fontSize="large" color="error" />,
  },
];

export default function UtilitiesHub() {
  const navigate = useNavigate();
  const items = useMemo(() => ITEMS, []);

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <PageHeader
        title="Utilitários"
        subtitle="Ferramentas operacionais: balança, Excel e etiquetas, no mesmo modelo do ZenPDV."
      />

      <Grid container spacing={2}>
        {items.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.route}>
            <Card variant="outlined" sx={{ height: '100%' }}>
              <CardActionArea sx={{ height: '100%' }} onClick={() => navigate(item.route)}>
                <CardContent>
                  <Stack spacing={1.5}>
                    {item.icon}
                    <Typography variant="h6" fontWeight={800}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.description}
                    </Typography>
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
